import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

interface BorderProps {
	borderWidth: number;
}

const StyledThemedItemEditor = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	pointer-events: auto;
`;

const Border = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	border: ${({ borderWidth }: BorderProps) => `${borderWidth}px solid ${NewStyleColor.Blue100}`};
	border-radius: inherit;
`;

export {
	StyledThemedItemEditor,
	Border,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ThemedItemEditor/styles.ts